'use client';

import React, { useEffect, useState } from 'react';

import { BlogCardVertical } from '../blog-card';
import { jakarta } from '@/lib/fonts';
import { cn } from '@/lib/utils';
import { Article } from '@/types/types';

export const ArticlesByCategory = ({
  title,
  category,
  numberOfArticles = 3,
  locale,
}: {
  title?: string;
  category: any;
  numberOfArticles?: number;
  locale: string;
}) => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      if (!category) {
        setLoading(false);
        return;
      }

      try {
        const categorySlug = category.slug || category.name?.toLowerCase().replace(/ /g, '-');
        if (!categorySlug) {
          setLoading(false);
          return;
        }

        const response = await fetch(
          `${process.env.NEXT_PUBLIC_STRAPI_URL || process.env.NEXT_PUBLIC_API_URL}/api/articles?filters[categories][slug][$eq]=${categorySlug}&locale=${locale}&populate=*&pagination[pageSize]=${numberOfArticles}`
        );
        const json = await response.json();
        
        // Strapi 5 might return data directly or nested in data
        const fetchedArticles = json.data || [];
        setArticles(fetchedArticles);
      } catch (error) {
        console.error('Error fetching articles by category:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, [category, locale, numberOfArticles]);

  if (loading) return null;
  if (articles.length === 0) return null;

  return (
    <div className="py-16 md:py-24 relative z-20">
      {title && (
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mb-12 text-center">
          <h2
            className={cn(
              jakarta.className,
              'text-3xl sm:text-4xl font-bold tracking-tight text-[#2e1452] dark:text-white'
            )}
          >
            {title}
          </h2>
        </div>
      )}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article: any, index: number) => (
            <BlogCardVertical
              key={`${article.slug || article.id}-${index}`}
              article={article}
              locale={locale}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArticlesByCategory;
